// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ResizeObserver$Showside from "../utils/ResizeObserver.bs.js";
import * as ScrollDirection$Showside from "../utils/ScrollDirection.bs.js";
import * as InlineContainerContext$Showside from "../context/InlineContainerContext.bs.js";
function emptyHook(param) {
  return 0;
}
var context = React.createContext({
  state: {
    primaryNavbarHeight: 0,
    secondaryNavbarHeight: 0,
    fixedSecondaryNavbarHeight: 0,
    dynamicSecondaryNavbarHeight: 0,
    toolbarHeight: 0,
    subMenuSliderHeight: 0,
    titleHeight: 0,
    showPrimaryNavbar: true,
    anchorsOffset: []
  },
  setState: function (param) {}
});
var provider = context.Provider;
function ListPageLayoutController$Context$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
    value: value,
    children: children
  });
}
ListPageLayoutController$Context$Provider.displayName = "ListPageLayoutController.Context.Provider";
var Provider = {
  provider: provider,
  make: ListPageLayoutController$Context$Provider
};
function use(param) {
  return React.useContext(context);
}
var Context = {
  context: context,
  Provider: Provider,
  use: use
};
function ListPageLayoutController(Props) {
  var onChange = Props.onChange;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var autoHidePrimaryNavbarOpt = Props.autoHidePrimaryNavbar;
  var children = Props.children;
  var autoHidePrimaryNavbar = autoHidePrimaryNavbarOpt !== undefined ? autoHidePrimaryNavbarOpt : true;
  var match = InlineContainerContext$Showside.use(undefined);
  var embedOffsetTop = match.embedOffsetTop;
  var match$1 = React.useState(function () {
    return {
      primaryNavbarHeight: 0,
      secondaryNavbarHeight: 0,
      fixedSecondaryNavbarHeight: 0,
      dynamicSecondaryNavbarHeight: 0,
      toolbarHeight: 0,
      subMenuSliderHeight: 0,
      titleHeight: 0,
      showPrimaryNavbar: true,
      anchorsOffset: []
    };
  });
  var setState = match$1[1];
  var state = match$1[0];
  var updateAnchorsOffset = function (state) {
    var anchorsOffset = state.showPrimaryNavbar ? [state.primaryNavbarHeight, state.secondaryNavbarHeight, state.toolbarHeight, Belt_Option.getWithDefault(embedOffsetTop, 0)] : [state.secondaryNavbarHeight, state.toolbarHeight, Belt_Option.getWithDefault(embedOffsetTop, 0)];
    return {
      primaryNavbarHeight: state.primaryNavbarHeight,
      secondaryNavbarHeight: state.secondaryNavbarHeight,
      fixedSecondaryNavbarHeight: state.fixedSecondaryNavbarHeight,
      dynamicSecondaryNavbarHeight: state.dynamicSecondaryNavbarHeight,
      toolbarHeight: state.toolbarHeight,
      subMenuSliderHeight: state.subMenuSliderHeight,
      titleHeight: state.titleHeight,
      showPrimaryNavbar: state.showPrimaryNavbar,
      anchorsOffset: anchorsOffset
    };
  };
  var setState$1 = React.useCallback(function (fn) {
    Curry._1(setState, function (previous) {
      var nextState = Curry._1(fn, previous);
      var nextState$1 = updateAnchorsOffset(nextState);
      Belt_Option.forEach(onChange, function (fn) {
        Curry._1(fn, nextState$1);
      });
      return nextState$1;
    });
  }, [setState]);
  var match$2 = ScrollDirection$Showside.useScrollable(Belt_Option.isSome(scrollableContainerRef) && autoHidePrimaryNavbar, scrollableContainerRef !== undefined ? Caml_option.nullable_to_opt(scrollableContainerRef.current) : undefined, undefined, undefined, undefined);
  var match$3 = ScrollDirection$Showside.useWindow(Belt_Option.isNone(scrollableContainerRef) && autoHidePrimaryNavbar, undefined, undefined, undefined, undefined);
  var scrollDirection = scrollableContainerRef !== undefined ? match$2[0] : match$3[0];
  React.useEffect(function () {
    if (autoHidePrimaryNavbar) {
      Curry._1(setState$1, function (previous) {
        return {
          primaryNavbarHeight: previous.primaryNavbarHeight,
          secondaryNavbarHeight: previous.secondaryNavbarHeight,
          fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
          dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
          toolbarHeight: previous.toolbarHeight,
          subMenuSliderHeight: previous.subMenuSliderHeight,
          titleHeight: previous.titleHeight,
          showPrimaryNavbar: scrollDirection === /* Up */0,
          anchorsOffset: previous.anchorsOffset
        };
      });
    }
  }, [scrollDirection]);
  var value = React.useMemo(function () {
    return {
      state: state,
      setState: setState$1
    };
  }, [state, setState$1]);
  return React.createElement(ListPageLayoutController$Context$Provider, {
    value: value,
    children: children
  });
}
ListPageLayoutController.displayName = "ListPageLayoutController";
function useGenericHeightSetter(logKey, ref, setter) {
  var size = ResizeObserver$Showside.useResizeObserver(undefined, ref);
  var height = Belt_Option.mapWithDefault(size, 0, function (size) {
    return size.height;
  });
  var match = React.useContext(context);
  var setState = match.setState;
  var log2 = function (info1, info2) {
    Belt_Option.forEach(logKey, function (param) {
      console.log("LPLC:setter", info1, info2, param);
    });
  };
  React.useEffect(function () {
    log2(height, ref.current);
    Curry._1(setState, Curry._1(setter, height));
    return function (param) {
      log2(0, ref.current);
      Curry._1(setState, Curry._1(setter, 0));
    };
  }, [height]);
  return height;
}
function usePrimaryNavbarHeightSetter(ref) {
  return useGenericHeightSetter(undefined, ref, function (height, previous) {
    return {
      primaryNavbarHeight: height,
      secondaryNavbarHeight: previous.secondaryNavbarHeight,
      fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
      dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
      toolbarHeight: previous.toolbarHeight,
      subMenuSliderHeight: previous.subMenuSliderHeight,
      titleHeight: previous.titleHeight,
      showPrimaryNavbar: previous.showPrimaryNavbar,
      anchorsOffset: previous.anchorsOffset
    };
  });
}
function useSecondaryNavbarHeightSetter(isFixed, ref) {
  return useGenericHeightSetter(undefined, ref, function (height, previous) {
    return {
      primaryNavbarHeight: previous.primaryNavbarHeight,
      secondaryNavbarHeight: height,
      fixedSecondaryNavbarHeight: isFixed ? height : previous.fixedSecondaryNavbarHeight,
      dynamicSecondaryNavbarHeight: isFixed ? previous.dynamicSecondaryNavbarHeight : height,
      toolbarHeight: previous.toolbarHeight,
      subMenuSliderHeight: previous.subMenuSliderHeight,
      titleHeight: previous.titleHeight,
      showPrimaryNavbar: previous.showPrimaryNavbar,
      anchorsOffset: previous.anchorsOffset
    };
  });
}
function useToolbarHeightSetter(ref) {
  return useGenericHeightSetter(undefined, ref, function (height, previous) {
    return {
      primaryNavbarHeight: previous.primaryNavbarHeight,
      secondaryNavbarHeight: previous.secondaryNavbarHeight,
      fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
      dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
      toolbarHeight: height,
      subMenuSliderHeight: previous.subMenuSliderHeight,
      titleHeight: previous.titleHeight,
      showPrimaryNavbar: previous.showPrimaryNavbar,
      anchorsOffset: previous.anchorsOffset
    };
  });
}
function useSubMenuSliderHeightSetter(ref) {
  return useGenericHeightSetter(undefined, ref, function (height, previous) {
    return {
      primaryNavbarHeight: previous.primaryNavbarHeight,
      secondaryNavbarHeight: previous.secondaryNavbarHeight,
      fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
      dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
      toolbarHeight: previous.toolbarHeight,
      subMenuSliderHeight: height,
      titleHeight: previous.titleHeight,
      showPrimaryNavbar: previous.showPrimaryNavbar,
      anchorsOffset: previous.anchorsOffset
    };
  });
}
function useTitleHeightSetter(ref) {
  return useGenericHeightSetter(undefined, ref, function (height, previous) {
    return {
      primaryNavbarHeight: previous.primaryNavbarHeight,
      secondaryNavbarHeight: previous.secondaryNavbarHeight,
      fixedSecondaryNavbarHeight: previous.fixedSecondaryNavbarHeight,
      dynamicSecondaryNavbarHeight: previous.dynamicSecondaryNavbarHeight,
      toolbarHeight: previous.toolbarHeight,
      subMenuSliderHeight: previous.subMenuSliderHeight,
      titleHeight: height,
      showPrimaryNavbar: previous.showPrimaryNavbar,
      anchorsOffset: previous.anchorsOffset
    };
  });
}
var make = ListPageLayoutController;
export { emptyHook, Context, make, useGenericHeightSetter, usePrimaryNavbarHeightSetter, useSecondaryNavbarHeightSetter, useToolbarHeightSetter, useSubMenuSliderHeightSetter, useTitleHeightSetter };
/* context Not a pure module */